const styles = (theme) => ({
  title: {
    fontSize: '16px',
    textTransform: 'uppercase',
    fontWeight: 'normal',
    color: theme.color.grey_55,
  },
});

export default styles;
